import type * as React from "react";

import { cn } from "@/web/lib/styling";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="withus-textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-none border bg-input px-3 py-2",
        // Load-bearing: mobile font must be >=16px so iOS Safari doesn't zoom on focus. Don't shrink below text-base under md.
        "text-base text-input-foreground outline-none md:text-sm",
        "placeholder:text-input-foreground/40",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-black/5 disabled:text-withus-dark-blue/50",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
